export const getLeaderboardQueryKey = (pageSize: number) => ['accounts', 'leaderboard', pageSize];
export const getOverallPointsQueryKey = (id: string) => ['accounts', 'user', id];
export const getUsersQueryKey = (userId: string) => ['users', userId];
